'use client';

import CatalogItIcon from './CatalogItIcon';

export default function ErrorMessage({
  message,
  subTitle
}: {
  message: string;
  subTitle?: string;
}) {
  return (
    <div className='flex flex-col items-center h-full gap-6 mt-20'>
      <CatalogItIcon size={100} />
      <h1 className='text-4xl font-bold text-center'>{message}</h1>
      {subTitle && <h2 className='text-xl text-center'>{subTitle}</h2>}

      <button
        onClick={() => {
          window.location.href = '/';
        }}
        className='text-white px-4 py-2 rounded-md text-xl cursor-pointer'
        style={{ backgroundColor: '#005F91' }}
      >
        Continue
      </button>
    </div>
  );
}
